import Box from '@mui/material/Box';
import Button, { type ButtonProps } from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';

interface LoadingButtonProps extends ButtonProps {
  loading?: boolean;
}

const LoadingButton = ({ loading, disabled, children, ...rest }: LoadingButtonProps) => {
  if (loading && rest.variant === 'text') {
    return (
      <Button {...rest} disabled endIcon={<CircularProgress size={14} color="primary" />}>
        {children}
      </Button>
    );
  }

  const visible = loading ? 'hidden' : 'visible';
  const spinnerColor = rest?.variant === 'contained' ? 'inherit' : 'primary';

  return (
    <Button disabled={disabled || loading} {...rest} sx={{ position: 'relative', ...rest.sx }}>
      <Box component="span" sx={{ visibility: visible }}>
        {children}
      </Box>
      {loading && (
        <CircularProgress
          size={18}
          color={spinnerColor}
          sx={{ position: 'absolute', top: '50%', left: '50%', mt: '-9px', ml: '-9px' }}
        />
      )}
    </Button>
  );
};

export default LoadingButton;
